import React from 'react';
import Modal from './Modal';

type OKCancelModalProps = {
  onOK: () => void;
  onCancel: () => void;
};

const OKCanelModal: React.FC<OKCancelModalProps> = props => {
  const { onOK, onCancel } = props;
  return (
    <div onClick={onCancel}>
      <Modal onClose={onCancel}>
        <div
          onClick={event => {
            event.stopPropagation();
          }}>
          {props.children}
          <div className="flex border-t border-solid border-gray-500">
            <div
              className="w-1/2 text-center py-1 font-bold cursor-pointer"
              onClick={onOK}>
              OK
            </div>
            <div
              className="w-1/2 text-center py-1 border-l border-solid border-gray-500 font-bold cursor-pointer"
              onClick={onCancel}>
              Cancel
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default OKCanelModal;
